const getWaitForIndex = (index, minIndex = 25, minWait = 100, elemWait = 50) => index < minIndex ? null : minWait + ((index - minIndex) * elemWait)

export default getWaitForIndex
